<div class="obcineMenu">
  <p-select
      *ngIf="(obList.length > 0)" 
      [options]="obList" 
      [(ngModel)]="selectedOb" 
      (onChange)="obChange($event)">
  </p-select>

  <i (click)="refresh()"
      class="pi pi-refresh refreshIcon"
      aria-hidden="true">
  </i>
</div>